module.exports = __webpack_public_path__ + "static/media/09.604b1acb.png";